import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  Alert,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ViewCtc = () => {
  const [payrollData, setPayrollData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPayrollDetails = async () => {
      try {
          const token = localStorage.getItem('token');
    if (!token) {
      alert("No authentication token found. Please log in.");
      return;
    }
  
    const payload = JSON.parse(atob(token.split('.')[1]));
    const company_id = payload.company_id;
        const response = await axios.get(`${API_URL}/api/payroll/viewctc`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          withCredentials: true
        });
        
        
        // Check if payroll data exists in the response
        if (response.data && response.data.payroll) {
          setPayrollData(response.data.payroll);
          setError('');
        } else {
          setError('No payroll data found in response');
          //console.error("No payroll data in response");
        }
      } catch (error) {
        //console.error("Error fetching payroll:", error);
        
        if (error.response) {
          //console.error("Response status:", error.response.status);
          //console.error("Response data:", error.response.data);
          
          if (error.response.status === 403) {
            setError(error.response.data.message || 'Access forbidden');
          } else if (error.response.status === 404) {
            setError('Payroll details not found');
          } else {
            setError(`Error fetching payroll details: ${error.response.data.message || error.message}`);
          }
        } else {
          setError(`Network error: ${error.message}`);
        }
        
        setPayrollData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchPayrollDetails();
  }, []);



  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom  fontWeight="bold">
        View CTC Details
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        payrollData && (
          <Card sx={{ mt: 4, mx: 'auto', maxWidth: 1400, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>Employee Information</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>Employee ID:</strong> {payrollData.employee_id}</Typography>
                  <Typography><strong>Name:</strong> {payrollData.firstName} {payrollData.lastName}</Typography>
                  <Typography><strong>Phone:</strong> {payrollData.phoneNumber}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>Email:</strong> {payrollData.companyemail}</Typography>
                  <Typography><strong>PF.NO:</strong> {payrollData.pfno}</Typography>
                  <Typography><strong>UAN:</strong> {payrollData.uan}</Typography>
                </Grid>
              </Grid>

              <Divider sx={{ my: 2 }} />
              
              {/* CTC Summary Table Added at Top */}
              <Typography variant="h6" gutterBottom>Cost to Company (CTC)</Typography>
              <TableContainer component={Paper} sx={{ mb: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell><strong>Total CTC</strong></TableCell>
                      <TableCell align="right"><strong>{Number(payrollData.ctc).toFixed(2)}</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                   
                    {Number(payrollData.joining_bonus) > 0 && (
                      <TableRow>
                        <TableCell>Joining Bonus</TableCell>
                        <TableCell align="right">{Number(payrollData.joining_bonus).toFixed(2)}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Divider sx={{ my: 2 }} />

              <Typography variant="h6" gutterBottom>Salary Details</Typography>
              <TableContainer component={Paper} sx={{ mb: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell><strong>Component</strong></TableCell>
                      <TableCell align="right"><strong>Monthly (₹)</strong></TableCell>
                      <TableCell align="right"><strong>Annual (₹)</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>Base Salary</TableCell>
                      <TableCell align="right">{(Number(payrollData.base_salary) / 12).toFixed(2)}</TableCell>
                      <TableCell align="right">{Number(payrollData.base_salary).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>HRA</TableCell>
                      <TableCell align="right">{(Number(payrollData.hra) / 12).toFixed(2)}</TableCell>
                      <TableCell align="right">{Number(payrollData.hra).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Special Allowance</TableCell>
                      <TableCell align="right">{(Number(payrollData.special_allowance) / 12).toFixed(2)}</TableCell>
                      <TableCell align="right">{Number(payrollData.special_allowance).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Performance Bonus</TableCell>
                      <TableCell align="right">{(Number(payrollData.performance_bonus) / 12).toFixed(2)}</TableCell>
                      <TableCell align="right">{Number(payrollData.performance_bonus).toFixed(2)}</TableCell>
                    </TableRow>
                    
                    {Number(payrollData.variable_salary) > 0 && (
                      <TableRow>
                        <TableCell>Variable Salary</TableCell>
                        <TableCell align="right">{(Number(payrollData.variable_salary) / 12).toFixed(2)}</TableCell>
                        <TableCell align="right">{Number(payrollData.variable_salary).toFixed(2)}</TableCell>
                      </TableRow>
                    )}
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell><strong>Gross Salary</strong></TableCell>
                      <TableCell align='right'><strong>
                        {(
                            (Number(payrollData.base_salary)/12)+
                            (Number(payrollData.hra)/12)+
                            (Number(payrollData.special_allowance)/12)+
                            (Number(payrollData.performance_bonus)/12)
                            
                        ).toFixed(2)}
                        </strong></TableCell>
                        <TableCell align='right'><strong>
                        {(
                            Number(payrollData.base_salary)+
                            Number(payrollData.hra)+
                            Number(payrollData.special_allowance)+
                            Number(payrollData.performance_bonus)
                        ).toFixed(2)}
                        </strong></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Divider sx={{ my: 2 }} />

              <Typography variant="h6" gutterBottom>Deductions</Typography>
              <TableContainer component={Paper} sx={{ mb: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell><strong>Component</strong></TableCell>
                      <TableCell align="right"><strong>Monthly (₹)</strong></TableCell>
                      <TableCell align="right"><strong>Annual (₹)</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>PF</TableCell>
                      <TableCell align="right">{(Number(payrollData.employeepf) / 12).toFixed(2)}</TableCell>
                      <TableCell align="right">{Number(payrollData.employeepf).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Professional Tax</TableCell>
                      <TableCell align="right">{(Number(payrollData.professional_tax)/12).toFixed(2)}</TableCell>
                      <TableCell align="right">{(Number(payrollData.professional_tax)).toFixed(2)}</TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell>Income Tax</TableCell>
                      <TableCell align="right">{Number(payrollData.monthly_tax).toFixed(2)}</TableCell>
                      <TableCell align="right">{Number(payrollData.total_tax).toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell><strong>Total Deductions</strong></TableCell>
                      <TableCell align="right">
                        <strong>
                          {((Number(payrollData.pf) / 12) + 
                            Number(payrollData.professional_tax) + 
                            Number(payrollData.monthly_tax)).toFixed(2)}
                        </strong>
                      </TableCell>
                      <TableCell align="right">
                        <strong>
                          {(Number(payrollData.pf) + 
                            (Number(payrollData.professional_tax) * 12) + 
                            Number(payrollData.total_tax)).toFixed(2)}
                        </strong>
                      </TableCell>
                    </TableRow> */}
                  </TableBody>
                </Table>
              </TableContainer>

            </CardContent>
          </Card>
        )
      )}
    </Box>
  );
};

export default ViewCtc;